(function () {
    "use strict";

    angular.module("app").factory("LibraryService", LibraryService);

    function LibraryService(WebApiService) {
        return {
            addColor: function (postData) {
                return WebApiService.postJson("/api/Library/AddColor", postData, {}, false);
            },
            addCuttingPattern: function (postData) {
                return WebApiService.postJson("/api/Library/AddCuttingPattern", postData, {}, false);
            },
            addLast: function addLast(postData) {
                return WebApiService.postJson("/api/Library/AddLast", postData, {}, false);
            },
            addMidsole: function (postData) {
                return WebApiService.postJson("/api/Library/AddMidsole", postData, {}, false);
            },
            addOutsole: function (postData) {
                return WebApiService.postJson("/api/Library/AddOutsole", postData, {}, false);
            },
            addPattern: function (postData) {
                return WebApiService.postJson("/api/Library/AddPattern", postData, {}, false);
            },
            addPatternDesc: function (postData) {
                return WebApiService.postJson("/api/Library/AddPatternDesc", postData, {}, false);
            },
      		addDevelopmentCenter: function (postData) {
	          return WebApiService.postJson('/api/Library/AddDevelopmentCenter', postData, {}, false);
			},
            lastExists: function (lastName, brandId) {
                return WebApiService.get("/api/Library/LastExists", { lastName: lastName, brandId: brandId }, {}, false);
            },
            addDeveloper: function (postData) {
                return WebApiService.postJson("/api/Library/AddDeveloper", postData, {}, false);
            },
            deleteDevelopers: function (postData) {
                return WebApiService.postJson("/api/Library/DeleteDevelopers", postData, {}, false);
            },
            updateDevelopmentCenter: function (postData) {
                return WebApiService.postJson("/api/Library/UpdateDevelopmentCenter", postData, {}, false);
            }
        };
    }
})();
